export const DOCUMENTS_ITEMS_PER_PAGE = 100;
export const DOCUMENTS_AUTO_RELOAD_MS = 5000;
